import type { DeepPartial } from '@tryiris-ai/common.protojs';
import type { State } from '@tryiris-ai/common.protojs/agent/v1/agent';

type RequestMutation = (set: DeepPartial<State>, unset: DeepPartial<State>) => Promise<unknown>;

/**
 * Immediate `reservation.discovering` write. Clearing is `false` (a set),
 * never an unset — old encoders ignore the unknown field.
 *
 * Per rule: wire-contract-changes-must-not-break-old-firmware (ai.knowledge/global).
 * See knowledge: state-sync-optimistic-mutations (ai.knowledge/studio.client).
 */
export const writeDiscoveringReservation = async (
  requestMutation: RequestMutation,
  sessionId: string,
  on: boolean
): Promise<void> => {
  await requestMutation(
    {
      control: {
        reservation: {
          [sessionId]: { discovering: on }
        }
      }
    },
    {}
  );
};
